import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseChecklistRoute() {
  return <AdminOperationsScreen screenIdOverride="case-checklist" />;
}
